import { defineStore } from 'pinia'

import chatApi from '@/modules/chat/api/chat'

export const useChatSearchMessagesHistoryStore = defineStore('chatSearchMessagesHistoryStore', {
  state: () => ({
    azureChatThreadId: null,
    messages: [],
    sortedMessages: [],
    searchingMessages: true,
    initialMessagesHaveBeenLoaded: false,
    allMessagesAreLoaded: false,
    messagesScroller: null,
    totalMessages: 0,
  }),
  actions: {
    async init(messagesScroller) {
      this.messagesScroller = messagesScroller
      this.allMessagesAreLoaded = false
    },
    updateSortedMessages() {
      this.sortedMessages = [...this.messages].filter((message) => message.content).sort((a, b) => {
        return a.id - b.id
      })
    },
    async loadMessages(page = 1) {
      const { data, total } = await chatApi.searchMessages(this.azureChatThreadId, this.searchQuery, page)
      if (!this.totalMessages) {
        this.totalMessages = total
      }
      return { data, total }
    },
    async initializeMessages(page = 1) {
      const pushMessage = async (message) => {
        const regex = new RegExp(this.searchQuery.trim(), 'gi')
        const highlightOutsideLinks = (text, searchRegex) => {
          return text.split(/(https?:\/\/[^\s<]+)/gi).map((segment) => {
            if (/^https?:\/\//.test(segment)) {
              return segment // keep URLs intact
            }
            return segment.replace(searchRegex, (m) => `<span class="c-chat__keyword">${m}</span>`)
          }).join('')
        }
        let messageContent = message.content.message
        if (message.metadata?.type === 'text') {
          messageContent = messageContent.replace(regex, (match) => `<span class="c-chat__keyword">${match}</span>`)
        } else if (message.metadata?.type === 'link') {
          messageContent = highlightOutsideLinks(messageContent, regex)
        } else if (message.metadata?.type === 'attachment' && message.metadata?.file_name) {
          message.metadata.file_name = message.metadata.file_name.replace(regex, (match) => `<span class="c-chat__keyword">${match}</span>`)
        }

        message.metadata.state = null
        this.messages.push({
          id: parseInt(message.id),
          content: messageContent,
          senderDisplayName: message.senderDisplayName,
          createdOn: message.createdOn,
          metadata: message.metadata,
        })
      }

      let currentPage = page
      let isDone = false

      const getMessages = async () => {
        if (isDone) {
          return
        }
        const { data } = await this.loadMessages(currentPage)
        await Promise.all(data.map(async (message) => {
          await pushMessage(message)
        }))

        setTimeout(() => {
          isDone = this.messages.length >= this.totalMessages
          if (isDone) {
            this.searchingMessages = false
            this.allMessagesAreLoaded = true
            this.initialMessagesHaveBeenLoaded = true
            this.updateSortedMessages()
            return
          }
          currentPage++
          getMessages()
        }, 500)
      }
      await getMessages()
    },
    async searchMessages(threadId, query) {
      this.azureChatThreadId = threadId
      this.searchQuery = query
      this.searchingMessages = true
      this.messages = []
      this.sortedMessages = []
      this.totalMessages = 0
      this.allMessagesAreLoaded = false
      this.initialMessagesHaveBeenLoaded = false
      this.messageIterator = undefined

      if (query) {
        await this.initializeMessages()
      }
    },
    scrollContainerDown() {
      if (this.messagesScroller) {
        this.messagesScroller.scrollToBottom()
      }
    },
  },
})
